export default __webpack_public_path__ + "static/1-c5ccea45c1b045be485e61edd8ec5d41.jpeg";